const makoResponseKeyExtractor = (s: any) => s.public_id || s


const dropdownChangeHandlerFactory =
    <OptionType>(keyExtractor = makoResponseKeyExtractor) =>
        (initialSelections: OptionType[] = [], updateSelections = (_s: OptionType[]) => { }) =>
            (selection: OptionType | OptionType[]) => {
                let keys = Array.isArray(selection) ? selection : [keyExtractor(selection)];

                keys = Array.from(new Set(keys));

                let updatedSelections = [...initialSelections];
                keys.forEach(key => {
                    if (updatedSelections.includes(key)) {
                        updatedSelections = updatedSelections.filter(s => s !== key);
                    } else {
                        updatedSelections.push(key);
                    }
                });

                updateSelections(updatedSelections);
            };


export const dropdownHandlerForQueryParamsFactory = ({ rawValues, setRawValues }: { rawValues: any; setRawValues: (values: any) => void }) =>
    (field: string) => dropdownChangeHandlerFactory()(rawValues[field], (s) => setRawValues({ [field]: s }))

